import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { PaymentGatewayActionMenu } from "./PaymentGatewayActionMenu";

export const getPaymentGatewayDefaultValues = () => ({
  payment_gateway_id: "",
  key_id: "",
  key_secret: "",
  webhook_secret: "",
  currency: "INR",
  country: "IN",
  gateway_type: "",
  name: "",
  domain: "",
});

export const paymentGatewayListColumns = (isReadOnly) => [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    minWidth: 150,
    renderCell: ({ value, id, row }) => (
      <>
        {isReadOnly ? (
          value || "-"
        ) : (
          <Link underline="none" component={RouterLink} to={`${id}`}>
            {value || "-"}
          </Link>
        )}
      </>
    ),
  },
  {
    field: "gateway_type",
    headerName: "Gateway Type",
    flex: 1,
    minWidth: 120,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "currency",
    headerName: "Currency",
    flex: 1,
    minWidth: 100,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "country",
    headerName: "Country",
    flex: 1,
    minWidth: 100,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "domain",
    headerName: "Domain",
    flex: 1,
    minWidth: 150,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "created_date",
    headerName: "Created Date",
    flex: 1,
    minWidth: 180,
    renderCell: ({ value }) => (
      <Tooltip title={value ? yearFirstDateTimeFormat(value) : "-"} placement="top">
        <span>{value ? yearFirstDateTimeFormat(value) : "-"}</span>
      </Tooltip>
    ),
  },
  ...(!isReadOnly
    ? [
        {
          field: "actions",
          headerName: "",
          type: "actions",
          width: 50,
          getActions: (params) => [
            <PaymentGatewayActionMenu id={params.id} row={params.row} />,
          ],
        },
      ]
    : []),
];

